var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#20A8E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 12.0122L29 15.0122L26.713 17.3002L23.713 14.3002L26 12.0122ZM14 24.0002V27.0002H17L25.299 18.7132L22.299 15.7132L14 24.0002ZM14 30.0002H30V32.0002H14V30.0002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadEditIcon);
export default __webpack_public_path__ + "static/media/Upload_Edit_icon.397b388538253a6438c8d737c9f205c9.svg";
export { ForwardRef as ReactComponent };